const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  pathname: state => state.app.pathname,
  token: state => state.user.token,
  hospitalName: state => state.user.hospitalName,
  hospitalId: state => state.user.hospitalId
}
export default getters



// WEBPACK FOOTER //
// ./src/modules/workorder/store/getters.js